<script>
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    NrIconButton,
    NrTooltip
  },

  props: {
    prettyId: { type: String, required: true }
  },

  computed: {
    ...mapState('requests', ['requests', 'filters']),
    ...mapState('request_show', ['filteredRequestLoading']),

    currentRequestIndex() {
      return this.requests.findIndex(
        (request) => String(this.prettyId) === String(request.id)
      )
    },

    disablePrevArrow() {
      return !this.cyclingEnabled || this.currentRequestIndex <= 0
    },

    disableNextArrow() {
      return (
        !this.cyclingEnabled ||
        this.currentRequestIndex >= this.requests.length - 1
      )
    },

    disabledNextArrowTooltip() {
      if (!this.cyclingEnabled) {
        return 'Request cycling is not active.'
      } else if (this.requests.length > 99) {
        return 'Only requests on the current page can be cycled through. To access more requests go back and choose a different page.'
      } else {
        return 'No more requests match your current filters.'
      }
    },

    cyclingEnabled() {
      return this.currentRequestIndex >= 0
    },

    disabledPrevArrowTooltip() {
      if (this.filters.page_number === 1) {
        return 'This is the first request matching your filters.'
      } else {
        return 'Only requests on the current page can be cycled through. To access more requests go back and choose a different page.'
      }
    }
  },

  methods: {
    ...mapMutations('request_show', ['setFilteredRequestLoading']),
    handlePrevClick() {
      this.setFilteredRequestLoading(true)
      this.$router.push(`/requests/${this.getPrevRequest()}`)
    },

    handleNextClick() {
      this.setFilteredRequestLoading(true)
      this.$router.push(`/requests/${this.getNextRequest()}`)
    },

    getNextRequest() {
      const request = this.requests[this.currentRequestIndex + 1]
      if (!request) return
      return request.id
    },

    getPrevRequest() {
      const request = this.requests[this.currentRequestIndex - 1]
      if (!request) return
      return request.id
    }
  }
}
</script>

<template>
  <div v-if="cyclingEnabled" class="request-show-title">
    <NrIconButton
      v-if="!disablePrevArrow"
      aria-label="previous page"
      class="m-right-8"
      size="normal"
      :icon="{ name: 'chevron-left' }"
      :disabled="filteredRequestLoading"
      variant="bordered-primary"
      @click="handlePrevClick"
    />

    <NrTooltip v-if="disablePrevArrow" :label="disabledPrevArrowTooltip">
      <NrIconButton
        size="normal"
        class="m-right-8"
        :disabled="true"
        aria-label="disabled previous page"
        :icon="{ name: 'chevron-left' }"
        variant="bordered-primary"
        @click="handlePrevClick"
      />
    </NrTooltip>

    <NrIconButton
      v-if="!disableNextArrow"
      size="normal"
      :icon="{ name: 'chevron-right' }"
      :disabled="filteredRequestLoading"
      aria-label="next page"
      variant="bordered-primary"
      @click="handleNextClick"
    />

    <NrTooltip v-if="disableNextArrow" :label="disabledNextArrowTooltip">
      <NrIconButton
        v-if="disableNextArrow"
        size="normal"
        :disabled="true"
        aria-label="disabled next page"
        :icon="{ name: 'chevron-right' }"
        variant="bordered-primary"
        @click="handleNextClick"
      />
    </NrTooltip>
  </div>
</template>

<style scoped lang="scss">
h1 {
  display: inline-block;
}
</style>
